/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { downloadSvg } from "svg-crowbar";
import styles from "./Character.module.css";
import * as d3 from "d3";
import _ from "lodash";
import Loader from "../Loader";

function Character({
  combinedParts,
  selectedCategory,
  selectedItem,
  genderSelected,
}) {
  const [bodyPart, setBodyPart] = React.useState(undefined);
  const [headPart, setHeadPart] = React.useState(undefined);
  const [facePart, setFacePart] = React.useState(undefined);

  const showPartsOfBody = [];
  const showPartsOfHead = [];
  const showPartsOfFace = [];

  const [loading, setLoading] = React.useState(false);

  const getBodyPart = async () => {
    const findBodies = _.find(combinedParts, function (o) {
      return o.type === "bodies";
    });

    const { default: svgFile } = await import(
      `../../data/${selectedCategory.toLowerCase()}/${genderSelected.toLowerCase()}/bodies/${
        combinedParts[0].skin
      }/${findBodies.path}`
    );

    const svgData = d3
      .svg(svgFile)
      .then((data) => data.getElementsByTagName("path"));

    return svgData;
  };

  const getHeadPart = async () => {
    const findHeads = _.find(combinedParts, function (o) {
      return o.type === "heads";
    });
    const { default: svgFile } = await import(
      `../../data/${selectedCategory.toLowerCase()}/${findHeads.path}`
    );

    const svgData = d3
      .svg(svgFile)
      .then((data) => data.getElementsByTagName("path"));

    return svgData;
  };

  const getFacePart = async () => {
    const findFaces = _.find(combinedParts, function (o) {
      return o.type === "faces";
    });
    const { default: svgFile } = await import(
      `../../data/${selectedCategory.toLowerCase()}/${findFaces.path}`
    );

    const svgData = d3
      .svg(svgFile)
      .then((data) => data.getElementsByTagName("path"));

    return svgData;
  };

  React.useEffect(() => {
    (async () => {
      try {
        const getBodies = await getBodyPart();
        const getHeads = await getHeadPart();
        const getFaces = await getFacePart();

        setBodyPart(getBodies);
        setHeadPart(getHeads);
        setFacePart(getFaces);
      } catch (error) {}

      setLoading(false);
    })();
  }, [combinedParts]);

  React.useEffect(() => {
    setLoading(true);
  }, [selectedItem]);

  if (bodyPart !== undefined) {
    for (let index = 0; index < bodyPart.length; index++) {
      const element = bodyPart[index];
      showPartsOfBody.push(element);
    }
  }

  if (headPart !== undefined) {
    for (let index = 0; index < headPart.length; index++) {
      const element = headPart[index];
      showPartsOfHead.push(element);
    }
  }

  if (facePart !== undefined) {
    for (let index = 0; index < facePart.length; index++) {
      const element = facePart[index];
      showPartsOfFace.push(element);
    }
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <svg
        id="character"
        width="100%"
        height={500}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -20 500 500"
      >
        <g transform="translate(10,-5)">
          {showPartsOfBody.length !== 0 && (
            <g transform={`translate(0,0)`}>
              {showPartsOfBody.map((path, index) => {
                return (
                  <path
                    key={index}
                    d={path.getAttribute("d")}
                    fill={path.getAttribute("fill")}
                  />
                );
              })}
            </g>
          )}
          {showPartsOfHead.length !== 0 && (
            <g transform={`translate(0,0)`}>
              {showPartsOfHead.map((path, index) => {
                return (
                  <path
                    key={index}
                    d={path.getAttribute("d")}
                    fill={path.getAttribute("fill")}
                  />
                );
              })}
            </g>
          )}
          {showPartsOfFace.length !== 0 && (
            <g transform={`translate(0,0)`}>
              {showPartsOfFace.map((path, index) => {
                return (
                  <path
                    key={index}
                    d={path.getAttribute("d")}
                    fill={path.getAttribute("fill")}
                  />
                );
              })}
            </g>
          )}
        </g>
      </svg>

      <button
        className={styles.downloadSVG}
        onClick={() => {
          downloadSvg(document.getElementById("character"));
        }}
      >
        Download SVG
      </button>
    </>
  );
}

export default Character;
